<app-header></app-header>


<div class="bg-light py-5" style="min-height: calc(100vh - 70px);">
  <div class="container">
    <div class="row g-4 justify-content-center">

      <div class="col-lg-5 col-md-8">
        <div class="card h-100 text-white border-0 shadow-sm rounded-4" style="background-color: #0073CF;">
          <div class="card-body d-flex flex-column text-center p-4">

            <div class="fs-1 mb-3" style="color: #EDC047;">
              <i class="bi bi-cpu"></i>
            </div>

            <h2 class="card-title fw-bold" style="color: #EDC047;">ExbeOn</h2>

            <p class="card-text flex-grow-1">
              Acesse a plataforma de gerenciamento inteligente, monitore processos e otimize suas operações em tempo real.
            </p> 
            <a routerLink="/exbeOn" class="btn btn-light rounded-pill align-self-center px-4 fw-bold">Acessar Plataforma</a>          </div>
        </div>
      </div>

      <div class="col-lg-5 col-md-8">
        <div class="card h-100 text-white border-0 shadow-sm rounded-4" style="background-color: #0073CF;">
          <div class="card-body d-flex flex-column text-center p-4">
            <div class="fs-1 mb-3" style="color: #EDC047;">
              <i class="bi bi-box-seam"></i>
            </div>
            <h2 class="card-title fw-bold" style="color: #EDC047;">ExbeGuardian</h2>
            <p class="card-text flex-grow-1">
              Controle total sobre seu inventário. Gerencie entradas, saídas, níveis de estoque e relatórios detalhados.
            </p>
            <a routerLink="/guardian/estoque" class="btn btn-light rounded-pill align-self-center px-4 fw-bold">Gerenciar Estoque</a>        </div>
      </div>

    </div>

     
      <div class="col-lg-4 col-md-6" *ngIf="mostrarCard">
        <div class="card h-100 text-white border-0 shadow-sm rounded-4" style="background-color: #0073CF;">
          <div class="card-body d-flex flex-column text-center p-4">
            <div class="fs-1 mb-3" style="color: #EDC047;">
              <i class="bi bi-person-plus-fill"></i>
            </div>
            <h2 class="card-title fw-bold" style="color: #EDC047;">Gestão de Acessos</h2>
            <p class="card-text flex-grow-1">
              Adicione novos usuários, defina permissões e gerencie o acesso aos sistemas de forma centralizada.
            </p>
            <a routerLink="/usuario" class="btn btn-light rounded-pill align-self-center px-4 fw-bold">Cadastrar Usuário</a>
          </div>
        </div>
      </div>
  </div>
</div>